import React, { memo, FC } from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { RowLayout } from "../../util/accordianStyles";
import useMaterialSelector from "./useMaterialSelector";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";

const MaterialAccordian: FC<{ dealer: string, email: string }> = ({ dealer, email }) => {
  const { variant, checkMark, handleClick, options } = useMaterialSelector(dealer, email);
  const { readOnly } = useIsReadOnlyContextProviderContext();

  return (
    <ReusableAccordian
      accordionName="material"
      heading="Material"
      secondaryHeading="Select material"
      required5={true}
    >
      <RowLayout>
        {options.map((state) => (
          <div key={state.id} onClick={() => readOnly ? null : handleClick(state.label)}>
            <Choices
              label={state.label}
              variant={variant(state.label)}
              checkMark={checkMark(state.label)}
              disabled={readOnly}
            />
          </div>
        ))}
      </RowLayout>
    </ReusableAccordian>
  );
};

export default memo(MaterialAccordian);
